module.exports = __webpack_public_path__ + "img/IG-Icon.5283a145.png";